import {useTranslation} from 'react-i18next';
import {
  BannerLink,
  Banner,
  InlineContent,
  TopRow,
  BottomRow,
  Logo,
  Subtitle,
  Price,
  RightText,
  Separator,
  LeftColumn,
  LeftRow,
  DiscountCode,
} from './styled';

import bigBgImage from './assets/new-desktop-banner.jpg?no-inline';
import bgImage from './assets/new-mobile-banner.webp?no-inline';
import logo from './assets/gigsky-logo.webp?no-inline';
import {GIGSKY_LINK} from './constants';

export function GigSkyBannerDesktop() {
  const {t} = useTranslation();

  return (
    <BannerLink href={GIGSKY_LINK} target="_blank">
      <Banner $bigBgImage={bigBgImage} $bgImage={bgImage} $logo={logo}>
        <InlineContent>
          <TopRow>
            <Logo src={logo} alt="gigsky-logo" height="19" width="100" />
          </TopRow>
          <BottomRow>
            <LeftColumn>
              <LeftRow>
                <Subtitle>{t('gigsky.travel_peacefully')}</Subtitle>
                <Separator />
                <Price>{t('gigsky.starting_price')}</Price>
              </LeftRow>
            </LeftColumn>
            <RightText>
              {t('gigsky.discount_prefix')}{' '}
              <DiscountCode>{t('gigsky.discount_code_value')}</DiscountCode>
            </RightText>
          </BottomRow>
        </InlineContent>
      </Banner>
    </BannerLink>
  );
}
